import { UcoastEl } from '@/scripts/core/UcoastEl'
import { TsDOM as q } from '@/scripts/core/TsDOM'

export class TabContent extends UcoastEl {
	static htmlSelector = 'tab-content'
	buttons: NodeListOf<HTMLButtonElement>
	contents: NodeListOf<HTMLElement>
	constructor() {
		super()
		this.buttons = q.rl<HTMLButtonElement>(
			'button[data-filter-button]',
			this
		)
		this.contents = q.rl<HTMLElement>('[data-filter-content]', this)
		this.buttons.forEach((button) => {
			button.addEventListener('click', () => {
				this.showContent(q.ra(button, 'data-filter-button'))
			})
		})
	}
	showContent(filter: string) {
		this.buttons.forEach((button) => {
			if (button.getAttribute('data-filter-button') === filter) {
				button.classList.add('underline-always')
				button.classList.remove('underline-on-hover')
			} else {
				button.classList.remove('underline-always')
				button.classList.add('underline-on-hover')
			}
		})
		this.contents.forEach((content) => {
			if (content.dataset?.filterContent === filter) {
				content.classList.remove('hidden')
			} else {
				content.classList.add('hidden')
			}
		})
	}
}
